const translations = {
    authentication: {
        login: {
            googleButton: 'Login with GGS Google account'
        }
    }
}
export default translations
